export const extraDomains = [
  {
    custom: false,
    name: 'pixamz.com',
    not_found_redirect: '',
    ssl: true,
  },
];
